"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_device_detect_1 = require("react-device-detect");
const i18next_1 = __importDefault(require("i18next"));
const postMessageToWVA_1 = __importDefault(require("@/webview_app/postMessageToWVA"));
const api_1 = require("@/api");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const detect_utils_1 = require("@/common/detect_utils");
function default_1({ totalAmount, buyerEmail, paymentDetail, paymentMethodDialog, setPaymentMethodDialog, confirm, disablePending, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const { user_id, id: orderId, room_fond_id, second_delivery_infos, room_title, second_payment_request, } = paymentDetail;
        const { payMethod, payInfo, isSecondPayment } = paymentMethodDialog;
        const isNativeApp = window.isNativeApp;
        const isCard = payMethod === 'card';
        const isVBank = payMethod === 'vbank';
        const isPaypal = payMethod === 'paypal';
        const isPaypalV2 = isPaypal && !isNativeApp;
        const openPaypalDialog = () => setPaymentMethodDialog(prev => (Object.assign(Object.assign({}, prev), { showPaypalDialog: true })));
        const closePaypalDialog = () => setPaymentMethodDialog(prev => (Object.assign(Object.assign({}, prev), { showPaypalDialog: false })));
        const closePaymentMethodDialog = () => setPaymentMethodDialog(prev => (Object.assign(Object.assign({}, prev), { showDialog: false })));
        // ! payMethod: pg
        // ? 'card': danal_tpay.9010040802
        // ? 'vbank':  uplus | danal_tpay.9010040802 | settle.imp_fondee (토스 | 다날 | 핵토)
        // ? 'trans': settle_acc.M2380070 | uplus (핵토 | 토스)
        // ? 'phone': danal.9010040802
        // ! 'paypal' + isNativeApp: paypal
        // ? 'paypal' + !isNativeApp: paypal_v2
        const impData = {};
        if (isPaypal) {
            const forexRate = yield (0, api_1.getData)('/api/v1/fondee/forex')
                .then(res => res.data.result.amount)
                .catch(() => 0);
            if (!forexRate) {
                disablePending();
                confirm({
                    description: i18next_1.default.t('환율 정보를 가져오지 못했습니다. 새로고침 후 다시시도해주세요.'),
                    cancellationButtonProps: { style: { display: 'none' } },
                });
                return;
            }
            else {
                isPaypalV2 && openPaypalDialog();
                const paypalUSD = (totalAmount / forexRate).toFixed(2);
                Object.assign(impData, { amount: paypalUSD, currency: 'USD' });
            }
        }
        else {
            Object.assign(impData, { amount: totalAmount });
        }
        const sel_vbank = payInfo === null || payInfo === void 0 ? void 0 : payInfo.sel_vbank;
        if (isVBank && sel_vbank === 'hec_vbank' && totalAmount < 300) {
            disablePending();
            confirm({
                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('최소 300원 이상 결제할 수 있어요.'), (0, jsx_runtime_1.jsx)("br", {}), `${i18next_1.default.t('금액이 부족하면 지갑 충전하여 결제해 주세요')} :)`] })),
                confirmationText: i18next_1.default.t('충전하기'),
            })
                .then(() => (window.location.href = '/credit/charge'))
                .catch(() => { });
            return;
        }
        if (isCard && totalAmount < 100) {
            disablePending();
            confirm({
                description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [i18next_1.default.t('카드결제는 최소 100원 이상 결제할 수 있어요.'), (0, jsx_runtime_1.jsx)("br", {}), i18next_1.default.t('내 통장 결제를 이용해 주세요!')] })),
                cancellationButtonProps: { style: { display: 'none' } },
            });
            return;
        }
        switch (payMethod) {
            case 'card':
                const isUsedCategory = 1018 <= room_fond_id && room_fond_id <= 1021;
                Object.assign(impData, {
                    pay_method: 'card',
                    pg: isUsedCategory ? 'settle.fondee01' : 'danal_tpay.9010040802',
                });
                break;
            case 'vbank':
                let vBankPg = '';
                if (sel_vbank === 'danal_vbank')
                    vBankPg = 'danal_tpay.9010040802';
                else if (sel_vbank === 'hec_vbank') {
                    Object.assign(impData, { company: '주식회사 폰디' });
                    vBankPg = 'settle.imp_fondee';
                }
                else
                    vBankPg = 'uplus';
                Object.assign(impData, { pay_method: 'vbank', pg: vBankPg, vbank_due: payInfo === null || payInfo === void 0 ? void 0 : payInfo.vbank_due });
                break;
            case 'trans':
                // FIXME: 내통장결제 핵토 -> 토스 변경 요청시 수정해야함 (settle_acc.M2380070 -> uplus)
                Object.assign(impData, { pay_method: 'trans', pg: 'settle_acc.M2380070' });
                break;
            case 'phone':
                Object.assign(impData, { pay_method: 'phone', pg: 'danal.9010040802' });
                break;
            case 'paypal':
                if (isPaypalV2) {
                    Object.assign(impData, { pay_method: 'paypal', pg: 'paypal_v2' });
                    const paypalInfo = payInfo === null || payInfo === void 0 ? void 0 : payInfo.paypal;
                    if (!!paypalInfo) {
                        const { sender_account_id, sender_first_name, sender_last_name, sender_email, sender_country_code, sender_create_date, dg_delivery_method, highrisk_txn_flag, sender_phone, } = paypalInfo;
                        const bypass = {
                            paypal_v2: {
                                additional_data: [
                                    { key: 'sender_account_id', value: sender_account_id },
                                    { key: 'sender_first_name', value: sender_first_name },
                                    { key: 'sender_last_name', value: sender_last_name },
                                    { key: 'sender_email', value: sender_email },
                                    { key: 'sender_country_code', value: sender_country_code },
                                    { key: 'sender_create_date', value: sender_create_date },
                                    { key: 'dg_delivery_method', value: dg_delivery_method },
                                    { key: 'highrisk_txn_flag', value: highrisk_txn_flag },
                                ],
                            },
                        };
                        if (!!sender_phone)
                            bypass.paypal_v2.additional_data.push({
                                key: 'sender_phone',
                                value: sender_phone,
                            });
                        Object.assign(impData, {
                            customer_id: user_id,
                            buyer_email: sender_email,
                            buyer_first_name: sender_first_name,
                            buyer_last_name: sender_last_name,
                            bypass,
                        });
                    }
                }
                else {
                    Object.assign(impData, { pay_method: 'card', pg: 'paypal' });
                }
                break;
        }
        const merchant_uid = `m_${user_id}_${new Date().getTime()}`;
        // ? custom_data: "{{ order_id }} {{ pay_status }} {{ user_id }} {{ amount }} {{ delivery_price }} {{origin_second_delivery_price }} {{use_credit}} {{second_payment_request_id}}"
        const custom_data = `${orderId} ${isSecondPayment ? 'second_pay' : 'after_pay'} ${user_id} ${totalAmount} ${second_delivery_infos.price} ${second_delivery_infos.origin_price} ${(payInfo === null || payInfo === void 0 ? void 0 : payInfo.cur_credit) || 0} ${(second_payment_request === null || second_payment_request === void 0 ? void 0 : second_payment_request.id) || 0}`;
        const m_redirect_url = window.location.href;
        const currentLang = (0, detect_utils_1.currentLanguage)();
        const languageKeyMapping = {
            ko: 'ko',
            ja: 'ko',
            en: 'en',
            zh_hans: 'zh',
        };
        const language = languageKeyMapping[currentLang];
        Object.assign(impData, {
            name: (0, string_utils_1.removeEmoji)(room_title).replace(/:/g, '') || '폰디 결제',
            merchant_uid,
            custom_data,
            m_redirect_url,
            language,
        });
        const buyer_tel = payInfo === null || payInfo === void 0 ? void 0 : payInfo.buyer_tel;
        const buyerTel = isPaypalV2 ? buyer_tel === null || buyer_tel === void 0 ? void 0 : buyer_tel.split(' 0').join('') : buyer_tel === null || buyer_tel === void 0 ? void 0 : buyer_tel.split(' ')[1];
        Object.assign(impData, { buyer_tel: buyerTel !== null && buyerTel !== void 0 ? buyerTel : '' });
        const buyer_name = payInfo === null || payInfo === void 0 ? void 0 : payInfo.buyer_name;
        !isPaypalV2 && Object.assign(impData, { buyer_name, buyer_email: buyerEmail });
        !isPaypal && Object.assign(impData, { digital: false });
        const isProduction = process.env.NODE_ENV === 'production';
        const impCode = isProduction ? 'imp94960200' : 'imp44489041';
        const impCallback = (rsp) => {
            const { success, imp_success } = rsp;
            const isSuccess = success === true || success === 'true' || imp_success === true || imp_success === 'true';
            if (isSuccess) {
                if (isVBank) {
                    window.location.replace(`/order/payment-detail-view/${orderId}?pay_method=vbank`);
                }
                else
                    window.location.reload();
            }
            else {
                if (isPaypalV2)
                    closePaypalDialog();
                alert(rsp.error_msg);
            }
        };
        const closeDialogAfterDelay = () => (0, functions_1.delay)(500).then(closePaymentMethodDialog);
        const IMP = window.IMP;
        if (isPaypalV2) {
            IMP.init(impCode);
            IMP.loadUI('paypal-spb', impData, impCallback);
            closeDialogAfterDelay();
        }
        else {
            if (isNativeApp) {
                const impObj = { impCode, impData };
                (0, postMessageToWVA_1.default)(`IAMPORT::${JSON.stringify(impObj)}`);
                closeDialogAfterDelay();
            }
            else {
                IMP.init(impCode);
                IMP.request_pay(impData, impCallback);
                if (react_device_detect_1.isMobile)
                    closeDialogAfterDelay();
            }
        }
        (0, functions_1.delay)(1000).then(disablePending);
    });
}
exports.default = default_1;
